import {
  BottomSheet,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Span,
  Text,
  Title,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { DialogContent, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { formatTimeWithTimezone } from "@src/appV2/redesign/utils/formatTimeWithTimezone";

interface UpdateEtaConfirmedBottomSheetProps {
  modalState: UseModalState;
  updatedEta?: Date;
  workplaceTimezone?: string;
  onEditMyEta: () => void;
}

export function UpdateEtaConfirmedBottomSheet(props: UpdateEtaConfirmedBottomSheetProps) {
  const { modalState, onEditMyEta, workplaceTimezone, updatedEta } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="outlined"
            endIconType="pencil"
            onClick={onEditMyEta}
          >
            Edit my ETA
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ textAlign: "left" }}>
        <Stack direction="column" spacing={8} px={2}>
          <Title variant="h3" component="h3">
            ETA Updated!
          </Title>
          <Stack direction="column" spacing={3}>
            <Text variant="body1">Don&apos;t forget:</Text>
            <List disablePadding dense>
              <ListItem>
                <ListItemIcon iconType="priority" sx={{ alignSelf: "initial" }} />
                <ListItemText
                  secondary={
                    <Text variant="body2">
                      Late arrivals still result in lateness penalties. A new ETA{" "}
                      <Span sx={{ fontWeight: "800", fontStyle: "italic" }}>is not</Span> a new
                      shift start time agreement.
                    </Text>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemIcon iconType="priority" sx={{ alignSelf: "initial" }} />
                <ListItemText
                  secondary={
                    <Text variant="body2">
                      {`If you are running ${
                        isDefined(updatedEta) && isDefined(workplaceTimezone)
                          ? `later than ${formatTimeWithTimezone(
                              updatedEta,
                              workplaceTimezone,
                              false
                            )}`
                          : "late again"
                      }, you should update your ETA again.`}
                    </Text>
                  }
                />
              </ListItem>
            </List>
          </Stack>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
